import * as React from "react";
import {
  IXGUIFieldBase,
  TOnChange,
  TXGUISelectOptionItem,
} from "../../../utils/interfaces/gui/fields.interfaces";

import {
  Divider,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const compareProps = (prevProps: any, nextProps: any) => {
  // return isEqual(prevProps, nextProps);
  return prevProps.currentValue === nextProps.currentValue;
};

interface XGUIToggleOptionFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
  options: TXGUISelectOptionItem[];
}

const XGUIToggleOptionField: React.FC<XGUIToggleOptionFieldProps> = React.memo(
  ({ field, currentValue, onChange, options = [] }) => {
    const id = `XGUI-FIELD-${field.name}`;
    const bp = useBreakpoint();

    const value: any = currentValue ?? field.defaultValue;

    return (
      <>
        <Stack
          className="XGUIToggleOption"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography component="label" htmlFor={id} width="40%">
            {field.label}
          </Typography>
          <ToggleButtonGroup
            sx={{ ml: 1 }}
            exclusive
            value={value}
            onChange={(_e, newValue) => {
              if (value !== newValue && newValue !== null) {
                onChange(newValue, field.name, bp);
              }
            }}
            aria-label={"toggle " + field.label}
            size="small"
            fullWidth
            color="primary"
          >
            {options.map((opt) => {
              const el = (
                <ToggleButton value={opt.value} key={opt.value.toString()}>
                  {opt.icon ?? opt.label ?? opt.value}
                </ToggleButton>
              );

              return el;
            })}
          </ToggleButtonGroup>
        </Stack>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 1 }} />
      </>
    );
  },
  compareProps
);

export default XGUIToggleOptionField;
